"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _tooltip = require("../components/global_components/tooltip");

var _tooltip2 = _interopRequireDefault(_tooltip);

var _ramda = require("ramda");

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _portal = require("../components/global_components/portal");

var _popup = require("../components/global_components/popup");

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withTooltipWrapper = function withTooltipWrapper(BaseComponent) {
  var TooltipWrapper = function (_Component) {
    _inherits(TooltipWrapper, _Component);

    function TooltipWrapper(props) {
      _classCallCheck(this, TooltipWrapper);

      var _this = _possibleConstructorReturn(this, (TooltipWrapper.__proto__ || Object.getPrototypeOf(TooltipWrapper)).call(this, props));

      _this.currentElement = {};
      _this.state = {
        display: "none",
        top: 0,
        left: 0,
        width: 0,
        arrowPosition: 0,
        text: "",
        secondaryText: ""
      };

      _this.showTooltip = _this.showTooltip.bind(_this);
      _this.hideTooltip = _this.hideTooltip.bind(_this);
      _this.handleEscKey = _this.handleEscKey.bind(_this);
      return _this;
    }

    _createClass(TooltipWrapper, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        document.body.addEventListener('keydown', this.handleEscKey);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.body.removeEventListener('keydown', this.handleEscKey);
      }
    }, {
      key: "handleEscKey",
      value: function handleEscKey(event) {
        var keyCode = event.keyCode;
        if (keyCode === 27) {
          this.hideTooltip(event);
        }
      }
    }, {
      key: "showTooltip",
      value: function showTooltip(e, text, secondaryText) {
        var _this2 = this;

        var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        var element = e.currentTarget;
        this.currentElement = element;
        var elementHeight = element.offsetHeight;
        var elementPosition = element.getBoundingClientRect();
        var elementWidth = element.parentNode.getBoundingClientRect().left;
        var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
        var arrowHeight = 13;
        var arrowWidth = 18;
        var elementMarginLeft = _string_utility2.default.stripCharacters(window.getComputedStyle(element).getPropertyValue("margin-left"));
        var elementMarginRight = _string_utility2.default.stripCharacters(window.getComputedStyle(element).getPropertyValue("margin-right"));
        var sumOfHorizontalMargins = (0, _ramda.sum)([parseInt(elementMarginLeft, 10), parseInt(elementMarginRight, 10)]);
        var arrowPosition = (0, _ramda.pathOr)(false, ["useOffsetLeftForArrowPosition"], props) ? element.offsetLeft - 4 : (element.offsetWidth + sumOfHorizontalMargins) / 2 - arrowWidth / 2;

        var topPos = (0, _ramda.pathOr)(false, ["placeLeftWithoutArrow"], props) ? arrowHeight + elementHeight + 10 : arrowHeight + elementHeight;
        var leftPos = (0, _ramda.pathOr)(false, ["placeLeftWithoutArrow"], props) ? elementWidth - 10 : elementWidth;

        this.setState((0, _ramda.merge)({
          display: (0, _ramda.pathOr)("inline-block", ["display"], props),
          top: elementPosition.top + docTop + topPos,
          left: leftPos,
          arrowPosition: arrowPosition,
          text: text,
          secondaryText: secondaryText,
          messageKey: (0, _ramda.pathOr)(false, ["messageKey"], props),
          isFundFavoritePopup: props.isFundFavoritePopup
        }, props), function () {
          if ((0, _ramda.is)(HTMLElement, _this2.currentElement) && (0, _ramda.is)(HTMLElement, document.getElementById("globalTooltip"))) {
            document.getElementById("globalTooltip").focus();
            document.getElementById("globalTooltip").style.outline = "none";
          }
        });
      }
    }, {
      key: "hideTooltip",
      value: function hideTooltip() {
        var _this3 = this;

        if (this.state.display !== "none") {
          this.setState({
            display: "none"
          }, function () {
            if ((0, _ramda.is)(HTMLElement, _this3.currentElement)) {
              _this3.currentElement.focus();
            }
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var tooltip = _react2.default.createElement(_tooltip2.default, _extends({}, this.state, { breakpoint: this.props.breakpoint, hideTooltip: this.hideTooltip }));
        if (this.state.isFundFavoritePopup) {
          tooltip = _react2.default.createElement(_popup2.default, _extends({}, this.state, { childEl: this.state.text, breakpoint: this.props.breakpoint }));
        }
        var tooltipComponent = this.props.usePortals ? _react2.default.createElement(
          _portal.Portal,
          null,
          tooltip
        ) : tooltip;

        return _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(BaseComponent, _extends({}, this.props, {
            showTooltip: this.showTooltip,
            hideTooltip: this.hideTooltip })),
          tooltipComponent
        );
      }
    }]);

    return TooltipWrapper;
  }(_react.Component);

  return TooltipWrapper;
};

exports.default = withTooltipWrapper;